// The two round buttons at the bottom right of the viewer: flip (top) and
// rotate (below it).
//
// The model-viewer fork drew these inside its own shadow DOM (template.js:
// #default-flip-button / #default-rotate-button, same 40px .fab as the AR
// button, 16px from the right and 116px / 66px from the bottom) and wired them
// to its flip() / rotate(). With the fork gone nothing draws them, so they are
// ordinary children of the element here (BZL-212). Children without a slot
// attribute land in model-viewer's default slot, which is positioned over the
// canvas.
//
// Icons are the fork's own (assets/flip-svg.js, assets/rotate-svg.js).

const stop = (e) => e.stopPropagation();

function Fab({ className, label, onClick, children }) {
  return (
    <button
      type="button"
      className={`viewer-fab ${className}`}
      aria-label={label}
      onClick={onClick}
      // Keep the press from reaching model-viewer's orbit controls.
      onPointerDown={stop}
      onMouseDown={stop}
      onTouchStart={stop}
    >
      {children}
    </button>
  );
}

export default function ViewerButtons({ gestures }) {
  return (
    <>
      <Fab
        className="viewer-fab-flip"
        label="Flip this 3D model to reverse side"
        onClick={() => gestures?.flip()}
      >
        <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            d="M2.854 7.146a.5.5 0 00-.708 0l-2 2a.5.5 0 10.708.708L2.5 8.207l1.646 1.647a.5.5 0 00.708-.708l-2-2zm13-1a.5.5 0 00-.708 0L13.5 7.793l-1.646-1.647a.5.5 0 00-.708.708l2 2a.5.5 0 00.708 0l2-2a.5.5 0 000-.708z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M8 3a4.995 4.995 0 00-4.192 2.273.5.5 0 01-.837-.546A6 6 0 0114 8a.5.5 0 01-1.001 0 5 5 0 00-5-5zM2.5 7.5A.5.5 0 013 8a5 5 0 009.192 2.727.5.5 0 11.837.546A6 6 0 012 8a.5.5 0 01.501-.5z"
            clipRule="evenodd"
          />
        </svg>
      </Fab>
      <Fab
        className="viewer-fab-rotate"
        label="Rotate this 3D model counter-clockwise"
        onClick={() => gestures?.rotate()}
      >
        <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            d="M12.83 6.706a5 5 0 00-7.103-3.16.5.5 0 11-.454-.892A6 6 0 112.545 5.5a.5.5 0 11.91.417 5 5 0 109.375.789z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M7.854.146a.5.5 0 00-.708 0l-2.5 2.5a.5.5 0 000 .708l2.5 2.5a.5.5 0 10.708-.708L5.707 3 7.854.854a.5.5 0 000-.708z"
            clipRule="evenodd"
          />
        </svg>
      </Fab>
    </>
  );
}
